import { getNamespacedResource } from "SharedStores/util";

const EDIT_FORM_NAMESPACE = "editForm";

const EDIT_FORM_NAMES = {
    //getters
    AVAILABLE_FIELDS_FROM_ELEMENT_CLASS_NAME: "availableFieldsFromElementClassName",
    ELEMENT_HAS_ERRORS: "elementHasErrors",
    ELEMENT_ERROR_BY_NAME: "elementErrorByName",
    ELEMENT_DATA_OR_PROP_BY_NAME: "elementDataOrPropByName",
    EDIT_ELEMENT_BY_ID: "editElementById",
    GET_UNIQUE_FIELD_NAME: "getUniqueFieldName",
    GET_ELEMENT_DEFINITION_ENABLED: "getElementDefinitionEnabled",
    GET_DRAFT_FORM_ID: "getDraftFormId",
    GET_UNIQUE_CLIENT_CREATABLE_URI: "getUniqueClientCreatableUri",
    ACTIVE_DRAFT_VALIDATION_ERRORS: "activeDraftValidationErrors",
    GET_EXTERNAL_EDITOR_BY_TYPE: "getExternalEditorByType",
    USER_FACING_DISALLOWED_CHARACTERS_REGEX: "userFacingDisallowedCharactersRegex",
    EXTERNAL_DATA_SCHEMAS: "externalDataSchemas",
    PV_CALCULATION_LOCATION_OPTION: "pvCalculationLocationOption",

    //mutations
    COMMIT_ELEMENT_PROPERTY_ERROR: "commitElementPropertyError",
    COMMIT_ELEMENT_DATA: "commitElementData",
    INIT_EDIT_ELEMENT_STATE: "initEditElementState",
    SET_DRAFT_FORM_ID: "setDraftFormId",
    COMMIT_SAVE_STATE: "commitSaveState",

    //actions
    CREATE_ELEMENT: "createElement",
    DELETE_ELEMENT: "deleteElement",
    RENAME_ELEMENT_FIELD: "renameElementField",
    SET_ELEMENT_PROPERTY_OR_DATA: "setElementPropertyOrData",
    INIT_STATE_FOR_ALL_ELEMENTS: "initStateForAllElements",
    DELETE_ELEMENT_DATA_FIELD_IF_NEW: "deleteElementDataFieldIfNew",
    DELETE_ELEMENT_DATA_FIELD_GROUP_IF_NEW: "deleteElementDataFieldGroupIfNew",
    DELETE_ELEMENT_ATTACHMENT_IF_NEW: "deleteElementAttachmentIfNew",
    SET_NEW_ELEMENT_DATA_SOURCE: "setNewElementDataSource",
    SET_ELEMENT_LABEL: "setElementLabel",
    SET_ELEMENT_DATA_FIELD: "setElementDataField",
    ADD_ELEMENT_EMPTY_LIST_ITEM: "addElementEmptyListItem",
    SET_ELEMENT_LIST_VIEW_ITEM: "setElementListViewItem",
    SET_ELEMENT_LIST_VIEW_ORDER: "setElementListViewOrder",
    ADD_ELEMENT_EMPTY_DATA_DEPENDENCY: "addElementEmptyDataDependency",
    SET_ELEMENT_DATA_DEPENDENCY: "setElementDataDependency",
    SET_ELEMENT_DATA_DEPENDENCY_ORDER: "setElementDataDependencyOrder",
    ADD_ELEMENT_EMPTY_SIGNATORY: "addElementEmptySignatory",
    REMOVE_ELEMENT_SIGNATORY: "removeElementSignatory",
    SET_ELEMENT_SIGNATORY_DATA: "setElementSignatoryData",
    CLEAR_ELEMENT_SIGNATORY_LIST: "clearElementSignatoryList",
    BUILD_ELEMENT_LIST_VIEW: "buildElementListView",
    ADD_EMPTY_VISIBILITY_RULE: "addEmptyVisibilityRule",
    DELETE_VISIBILITY_RULE: "deleteVisibilityRule",
    SET_VISIBILITY_RULE: "setVisibilityRule",
    SET_ELEMENT_GENERATED_DOCUMENT_TEMPLATE: "setElementGeneratedDocumentTemplate",
    SET_ELEMENT_ATTACHMENT_DATA: "setElementAttachmentData",
    SET_PV_ELEMENT_SHOW_BATTERY: "setPVElementShowBattery",
    MUTATE_AND_MARK_CHANGED: "mutateAndMarkChanged",
    SET_DRAFT_VALIDATION_ERRORS: "setDraftValidationErrors"
};

const EDIT_FORM_TYPES = {
    getters: {
        [EDIT_FORM_NAMES.AVAILABLE_FIELDS_FROM_ELEMENT_CLASS_NAME]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.AVAILABLE_FIELDS_FROM_ELEMENT_CLASS_NAME
        ),
        [EDIT_FORM_NAMES.ELEMENT_HAS_ERRORS]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.ELEMENT_HAS_ERRORS
        ),
        [EDIT_FORM_NAMES.ELEMENT_ERROR_BY_NAME]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.ELEMENT_ERROR_BY_NAME
        ),
        [EDIT_FORM_NAMES.ELEMENT_DATA_OR_PROP_BY_NAME]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.ELEMENT_DATA_OR_PROP_BY_NAME
        ),
        [EDIT_FORM_NAMES.EDIT_ELEMENT_BY_ID]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.EDIT_ELEMENT_BY_ID
        ),
        [EDIT_FORM_NAMES.GET_UNIQUE_FIELD_NAME]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.GET_UNIQUE_FIELD_NAME
        ),
        [EDIT_FORM_NAMES.GET_ELEMENT_DEFINITION_ENABLED]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.GET_ELEMENT_DEFINITION_ENABLED
        ),
        [EDIT_FORM_NAMES.GET_DRAFT_FORM_ID]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.GET_DRAFT_FORM_ID
        ),
        [EDIT_FORM_NAMES.GET_UNIQUE_CLIENT_CREATABLE_URI]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.GET_UNIQUE_CLIENT_CREATABLE_URI
        ),
        [EDIT_FORM_NAMES.ACTIVE_DRAFT_VALIDATION_ERRORS]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.ACTIVE_DRAFT_VALIDATION_ERRORS
        ),
        [EDIT_FORM_NAMES.GET_EXTERNAL_EDITOR_BY_TYPE]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.GET_EXTERNAL_EDITOR_BY_TYPE
        ),
        [EDIT_FORM_NAMES.USER_FACING_DISALLOWED_CHARACTERS_REGEX]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.USER_FACING_DISALLOWED_CHARACTERS_REGEX
        ),
        [EDIT_FORM_NAMES.EXTERNAL_DATA_SCHEMAS]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.EXTERNAL_DATA_SCHEMAS
        )
    },
    mutations: {
        [EDIT_FORM_NAMES.COMMIT_ELEMENT_PROPERTY_ERROR]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.COMMIT_ELEMENT_PROPERTY_ERROR
        ),
        [EDIT_FORM_NAMES.COMMIT_ELEMENT_DATA]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.COMMIT_ELEMENT_DATA
        ),
        [EDIT_FORM_NAMES.INIT_EDIT_ELEMENT_STATE]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.INIT_EDIT_ELEMENT_STATE
        ),
        [EDIT_FORM_NAMES.SET_DRAFT_FORM_ID]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.SET_DRAFT_FORM_ID
        ),
        [EDIT_FORM_NAMES.COMMIT_SAVE_STATE]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.COMMIT_SAVE_STATE
        )
    },
    actions: {
        [EDIT_FORM_NAMES.SET_ELEMENT_PROPERTY_OR_DATA]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.SET_ELEMENT_PROPERTY_OR_DATA
        ),
        [EDIT_FORM_NAMES.CREATE_ELEMENT]: getNamespacedResource(EDIT_FORM_NAMESPACE, EDIT_FORM_NAMES.CREATE_ELEMENT),
        [EDIT_FORM_NAMES.DELETE_ELEMENT]: getNamespacedResource(EDIT_FORM_NAMESPACE, EDIT_FORM_NAMES.DELETE_ELEMENT),
        [EDIT_FORM_NAMES.RENAME_ELEMENT_FIELD]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.RENAME_ELEMENT_FIELD
        ),
        [EDIT_FORM_NAMES.INIT_STATE_FOR_ALL_ELEMENTS]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.INIT_STATE_FOR_ALL_ELEMENTS
        ),
        [EDIT_FORM_NAMES.DELETE_ELEMENT_DATA_FIELD_IF_NEW]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.DELETE_ELEMENT_DATA_FIELD_IF_NEW
        ),
        [EDIT_FORM_NAMES.DELETE_ELEMENT_DATA_FIELD_GROUP_IF_NEW]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.DELETE_ELEMENT_DATA_FIELD_GROUP_IF_NEW
        ),
        [EDIT_FORM_NAMES.DELETE_ELEMENT_ATTACHMENT_IF_NEW]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.DELETE_ELEMENT_ATTACHMENT_IF_NEW
        ),
        [EDIT_FORM_NAMES.SET_NEW_ELEMENT_DATA_SOURCE]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.SET_NEW_ELEMENT_DATA_SOURCE
        ),
        [EDIT_FORM_NAMES.SET_ELEMENT_LABEL]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.SET_ELEMENT_LABEL
        ),
        [EDIT_FORM_NAMES.SET_ELEMENT_DATA_FIELD]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.SET_ELEMENT_DATA_FIELD
        ),
        [EDIT_FORM_NAMES.ADD_ELEMENT_EMPTY_LIST_ITEM]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.ADD_ELEMENT_EMPTY_LIST_ITEM
        ),
        [EDIT_FORM_NAMES.SET_ELEMENT_LIST_VIEW_ITEM]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.SET_ELEMENT_LIST_VIEW_ITEM
        ),
        [EDIT_FORM_NAMES.SET_ELEMENT_LIST_VIEW_ORDER]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.SET_ELEMENT_LIST_VIEW_ORDER
        ),
        [EDIT_FORM_NAMES.BUILD_ELEMENT_LIST_VIEW]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.BUILD_ELEMENT_LIST_VIEW
        ),
        [EDIT_FORM_NAMES.ADD_ELEMENT_EMPTY_DATA_DEPENDENCY]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.ADD_ELEMENT_EMPTY_DATA_DEPENDENCY
        ),
        [EDIT_FORM_NAMES.SET_ELEMENT_DATA_DEPENDENCY]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.SET_ELEMENT_DATA_DEPENDENCY
        ),
        [EDIT_FORM_NAMES.SET_ELEMENT_DATA_DEPENDENCY_ORDER]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.SET_ELEMENT_DATA_DEPENDENCY_ORDER
        ),
        [EDIT_FORM_NAMES.ADD_ELEMENT_EMPTY_SIGNATORY]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.ADD_ELEMENT_EMPTY_SIGNATORY
        ),
        [EDIT_FORM_NAMES.REMOVE_ELEMENT_SIGNATORY]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.REMOVE_ELEMENT_SIGNATORY
        ),
        [EDIT_FORM_NAMES.SET_ELEMENT_SIGNATORY_DATA]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.SET_ELEMENT_SIGNATORY_DATA
        ),
        [EDIT_FORM_NAMES.CLEAR_ELEMENT_SIGNATORY_LIST]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.CLEAR_ELEMENT_SIGNATORY_LIST
        ),
        [EDIT_FORM_NAMES.ADD_EMPTY_VISIBILITY_RULE]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.ADD_EMPTY_VISIBILITY_RULE
        ),
        [EDIT_FORM_NAMES.DELETE_VISIBILITY_RULE]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.DELETE_VISIBILITY_RULE
        ),
        [EDIT_FORM_NAMES.SET_VISIBILITY_RULE]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.SET_VISIBILITY_RULE
        ),
        [EDIT_FORM_NAMES.SET_ELEMENT_GENERATED_DOCUMENT_TEMPLATE]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.SET_ELEMENT_GENERATED_DOCUMENT_TEMPLATE
        ),
        [EDIT_FORM_NAMES.SET_ELEMENT_ATTACHMENT_DATA]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.SET_ELEMENT_ATTACHMENT_DATA
        ),
        [EDIT_FORM_NAMES.SET_PV_ELEMENT_SHOW_BATTERY]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.SET_PV_ELEMENT_SHOW_BATTERY
        ),
        [EDIT_FORM_NAMES.MUTATE_AND_MARK_CHANGED]: getNamespacedResource(
            EDIT_FORM_NAMESPACE,
            EDIT_FORM_NAMES.MUTATE_AND_MARK_CHANGED
        )
    }
};

export const SET_FULL_FORM_VALIDATION_ERRORS = getNamespacedResource(
    EDIT_FORM_NAMESPACE,
    EDIT_FORM_NAMES.SET_DRAFT_VALIDATION_ERRORS
);
export { EDIT_FORM_NAMESPACE, EDIT_FORM_TYPES, EDIT_FORM_NAMES };
